<template>
    <table v-if="posicao" class="table table-hover table-striped">
        <thead class="btn-info">
            <tr>
                <th style="padding: 10px">POSIÇÕES ATUAIS</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="padding: 5px">
                    DATA EVENTO: &nbsp;<b>{{posicao.date_time_event || posicao.date_time_evento | date("DD-MM-YYYY HH:mm:ss")}}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    DATA GPS: &nbsp;<b>{{posicao.date_time_gps | date("DD-MM-YYYY HH:mm:ss")}}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    DATA SERVIDOR: &nbsp;<b>{{posicao.date_time | date("DD-MM-YYYY HH:mm:ss")}}</b>
                </td>
            </tr>
            <tr>
                <td style="padding: 5px">
                    <span v-if="posicao.inputs.TensaoModulo">BATERIA: <b>{{posicao.inputs.TensaoModulo}}</b></span>
                    <span v-else>TENSÃO DO MÓDULO: <b>{{posicao.tensao_modulo}} v</b></span>
                     &nbsp;&nbsp;&nbsp;&nbsp;
                    RPM: <b>{{posicao.rpm}} rpm</b> &nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="posicao.inputs.ChargedBattery">BATERIA: <b>{{ posicao.inputs.ChargedBattery }}</b></span>
                    <span v-if="posicao.inputs.IButtonID">IButton - ID: <b>{{ posicao.inputs.IButtonID }}</b></span>
                </td>
            </tr>
            <tr>
                <td style="padding: 5px">
                    IGN: &nbsp;
                    <b class="text-success" v-if="posicao.ignition === 'ON'">LIGADA</b>
                    <b v-else>DESLIGADO</b> &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    POSIÇÃO VÁLIDA: &nbsp;
                        <b v-if="posicao.gps_valido" style="color: #0a4b3e">SIM</b>
                        <b v-else style="color: #f1586a">NÃO</b>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    VEL.: &nbsp;<b>{{posicao.speed}} km/h</b>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="posicao.num_sat">SAT.: <b>{{Number(posicao.num_sat)}}</b></span>
                    <span v-else-if="posicao.sat_num">SAT.: <b>{{Number(posicao.sat_num)}}</b></span>
                    <span v-else>SAT.: <b>0</b></span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="posicao.altitude">Altitude.: <b>{{posicao.altitude}} m</b></span>
                </td>
            </tr>

            <tr>
                <td style="padding: 5px">
                    HODÔMETRO.: <b>{{(posicao.odometro / 1000).toFixed(1)}} km</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; HORÍMETRO.: <b>{{ calc(posicao.horimetro)}}</b>
                </td>
            </tr>
            <tr>
                <td style="padding: 5px">
                    <b class="text-uppercase">
                        <vk-icon ratio="0.7" icon="location"></vk-icon>
                        {{posicao.localization}} | {{posicao.lat}}, {{posicao.long}}
                    </b>
                </td>
            </tr>
            <tr class="btn-info">
                <th style="padding: 10px">SAÍDAS</th>
            </tr>
            <tr>
                <td style="padding: 5px">
                    BLOQUEIO: &nbsp;<b v-if="posicao.outputs.Output1" style="color: #f1586a">ACIONADO</b><b v-else style="color: #0a4b3e">DESACIONADO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    SAÍDA 2: &nbsp;<b v-if="posicao.outputs.Output2" style="color: #f1586a">ACIONADA</b><b v-else style="color: #0a4b3e">DESACIONADA</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </td>
            </tr>

            <tr class="btn-info">
                <th style="padding: 10px">ENTRADAS</th>
            </tr>
            <tr>
                <td style="padding: 5px">
                    BATERIA: &nbsp;<b v-if="posicao.inputs.Battery" style="color: #f1586a">VIOLADA</b><b v-else style="color: #0a4b3e">NORMAL</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    VEL. EXCEDIDA: &nbsp;<b v-if="posicao.inputs.Speed" style="color: #f1586a">VIOLADA</b><b v-else style="color: #0a4b3e">NORMAL</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ENTRADA 1: &nbsp;<b v-if="posicao.inputs.Input1" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ENTRADA 2: &nbsp;<b v-if="posicao.inputs.Input2" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </td>
            </tr>
            <tr>
                <td style="padding: 5px">
                    JAMMER: &nbsp;<b v-if="posicao.inputs.Jammer" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    PÂNICO: &nbsp;<b v-if="posicao.inputs.Panic" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    MOVIMENTO INDEVIDO: &nbsp;<b v-if="posicao.inputs.Movement" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ANCORADO: &nbsp;<b v-if="posicao.ancorado" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b>
                </td>
            </tr>

            <tr>
                <td style="padding: 5px">
                    TEMPERATURA 1: &nbsp;<b style="color: #0a4b3e">{{ posicao.inputs.Temp1 }} &deg;</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    TEMPERATURA 2: &nbsp;<b style="color: #0a4b3e">{{ posicao.inputs.Temp2 }} &deg;</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    TEMPERATURA 3: &nbsp;<b style="color: #0a4b3e">{{ posicao.inputs.Temp3 }} &deg;</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ANTI FURTO: &nbsp;<b v-if="posicao.inputs.Antifurto" style="color: #f1586a">SIM</b><b v-else style="color: #0a4b3e">NÃO</b>
                </td>
            </tr>

        </tbody>
    </table>
    <table v-else>
        <tr>
            <td>AGUARDANDO POSIÇÃO</td>
        </tr>
    </table>
</template>
<script>
    import {date} from '../../../filter';
    import {Horimetro} from '../../../class/horimetro';
    export default {
        name: 'PosicaoAtual',
        props: {
            posicao: {
                "default": null
            }
        },
        filters: {
            date
        },
        methods: {
            calc (hori) {
                return Horimetro.calcHorimetro(hori);
            }
        }
    };
</script>
